exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen {\n.description[data-v-d5a7b886] {\n    margin-left: 30px;\n    margin-top: 10px;\n}\n.title-select[data-v-d5a7b886] {\n    margin-left: 15px;\n}\n.radio-1[data-v-d5a7b886] {\n    margin-left: 15px;\n}\n.radio-2[data-v-d5a7b886] {\n    margin-left: 15px;\n}\n}\n", ""]);

// exports
